export const convertDate = (date) => {
  const convertedDate = new Date(date * 1000);
  return `${convertedDate.getFullYear()}-${
    convertedDate.getMonth() + 1
  }-${convertedDate.getDate()}`;
};
